import type { Listing } from '~/models'
import { getMaxSubstringLength } from './flyers'

export function getReportListingName(listing: Listing) {
  const originalName = listing.name || listing.property.address || ''
  const name = originalName.substring(
    0,
    getMaxSubstringLength(originalName, 52)
  )

  return name.length < originalName.length ? `${name}...` : name
}
